import errorBoundary from '@ifeng/errorBoundary';
import React from 'react';
import { jsonp } from '@ifeng/ui_base';
import { callApp, getSchemeLink } from '@ifeng/callapp';
import { WxLaunchApp, QQShare } from 'ThreeTerminal_mobile';
import styles from './index.css';
import Haibao from './haibao';
import md5 from '@ifeng/md5';

const goToClientUrl =
    (window.allData && window.allData.introduction) || 'https://ishare.ifeng.com/c/specialClient/8877adCSsuO';

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    while (window[jsonpCallbackName]) {
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

class Layout extends React.PureComponent {
    state = {
        allList: [],
        filterList: [],
        isSearch: false,
        inputText: '',
        bref: '',
        tip: '',
        hasShadow: false,
    };

    searchRef = React.createRef();

    async componentDidMount() {
        document.title = (window.allData && window.allData.title) || '企业驰援河南捐赠榜';
        const jsonpCallback = createJsonpCallbackName('henanContribution');
        const result = await jsonp(
            `https://shankapi.ifeng.com/feedflow/coopdoc/doc_073353d6782e37ec99cf97ed4ecead20/info/${jsonpCallback}`,
            {
                jsonpCallback,
                cache: false,
            },
        );

        if (result && result.code === 0 && result.data) {
            this.setState({
                bref: result.data.desc || '',
                tip: result.data.remark || '',
                allList: result.data.list || [],
                filterList: result.data.list || [],
            });
        }

        let flage = true;

        window.addEventListener('scroll', () => {
            if (this.searchRef.current.getBoundingClientRect().top <= 0 && flage) {
                flage = false;
                this.setState({
                    hasShadow: true,
                });
            }
            if (this.searchRef.current.getBoundingClientRect().top > 1 && !flage) {
                flage = true;
                this.setState({
                    hasShadow: false,
                });
            }
        });
    }

    handleClick = (isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        const isClient = (window.allData && window.allData.devicetype === 'client') || false;

        if (isCallAppWx && !isClient) {
            callApp({
                docType: 'web',
                pid: goToClientUrl,
                kind: 'share01',
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    searchHandle = () => {
        const { inputText, allList } = this.state;
        const filterList = [];

        if (inputText.trim() !== '') {
            allList.map(item => {
                if (item.company && item.company.includes(inputText)) {
                    filterList.push(item);
                }

                return item;
            });
        }

        this.setState({
            filterList,
            isSearch: true,
        });
    };

    changeInput = event => {
        const { allList } = this.state;

        if (event.target.value !== '') {
            this.setState({
                inputText: event.target.value,
            });
        } else {
            this.setState({
                isSearch: false,
                inputText: '',
                filterList: allList,
            });
        }
    };

    returnList = () => {
        const { allList } = this.state;

        this.setState({
            filterList: allList,
            inputText: '',
            isSearch: false,
        });
    };

    render() {
        const { filterList, bref, tip, isSearch, inputText, hasShadow, allList } = this.state;
        const isClient = (window.allData && window.allData.devicetype === 'client') || false;
        const schemeLink = getSchemeLink({
            docType: 'web',
            pid: goToClientUrl,
            kind: 'share01',
        });
        const qqShareCofig = {
            title:
                (document.querySelector('#ifeng_share_title') &&
                    document.querySelector('#ifeng_share_title').innerText) ||
                '凤凰新闻｜企业驰援河南捐赠榜',
            img:
                (document.querySelector('#ifeng_share_thumbnail') &&
                    document.querySelector('#ifeng_share_thumbnail').innerText) ||
                'https://x0.ifengimg.com/ucms/2021_30/09CDAF774A0F2BB348A3102BF59BE76CB84011D1_size324_w750_h378.png',
            desc:
                (document.querySelector('#ifeng_share_description') &&
                    document.querySelector('#ifeng_share_description').innerText) ||
                '',
            cb: () => {
                console.log('分享成功');
            },
        };

        return (
            <div className={styles.pageBody}>
                <div className={`${styles.searchBox} ${hasShadow ? styles.searchBoxShadow : ''}`} ref={this.searchRef}>
                    <div className={styles.search}>
                        <input type="text" onChange={this.changeInput} value={inputText} placeholder="搜索捐赠企业" />
                        {inputText && <div className={styles.closeIcon} onClick={this.returnList} />}
                    </div>
                    {isSearch ? (
                        <div onClick={this.returnList} className={styles.searchIcon}>
                            取消
                        </div>
                    ) : (
                        <div onClick={this.searchHandle} className={styles.searchIcon}>
                            搜索
                        </div>
                    )}
                </div>
                {!isSearch ? (
                    <div className={styles.searchBref}>
                        <div className={styles.banner}>{bref}</div>
                        <div className={styles.tip}>{tip}</div>
                    </div>
                ) : (
                    ''
                )}
                <div className={styles.tableList}>
                    <div className={styles.tableHead}>
                        <div className={styles.tableTd1}>企业名称</div>
                        <div className={styles.tableTd2}>捐款数据及物资等</div>
                    </div>
                    <div className={styles.tableBody}>
                        {filterList.length > 0 ? (
                            filterList.map((item, index) => {
                                return (
                                    <div className={styles.tableTr} key={index}>
                                        <div className={styles.tableTd1}>
                                            <div className={styles.company}>{item.company || ''}</div>
                                            <div className={styles.companyType}>
                                                {item.type ? `（${item.type}）` : ''}
                                            </div>
                                        </div>
                                        <div className={styles.tableTd2}>
                                            <div className={styles.contributionData}>{item.info || ''}</div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className={styles.searchInfo}>
                                {inputText ? '您搜索的企业没有进入榜单' : '抱歉，请您输入企业名称后再搜索'}
                            </div>
                        )}
                    </div>
                </div>
                {!isClient ? (
                    <div className={styles.coypRight} onClick={this.handleClick}>
                        <img
                            className={styles.coypRightPic}
                            src="https://x0.ifengimg.com/ucms/2021_30/8FFBCCE1DF68A231841404F4C3CB99D01B995459_size18_w690_h80.png"
                        />
                        <WxLaunchApp
                            launchType="app"
                            launchAppClick={this.handleClick.bind(this, true, false, false)}
                            schemeLink={schemeLink}
                            launchAppFail={this.handleClick.bind(this, false, true, true)}
                        />
                    </div>
                ) : (
                    ''
                )}
                <QQShare content={qqShareCofig} />
                <Haibao bref={bref} tip={tip} allList={allList.slice(0, 10)} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
